import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyleSheet} from 'react-native';
import {staticNumberFormatter} from '../../../utils/NumberFormatter';
import IconTextSwitchItem from './IconTextSwitchItem';

export default function WalletItem(props) {
  const {balance} = props;
  const {t} = useTranslation();

  return (
    <IconTextSwitchItem
      icon={'wallet'}
      title={t('wallet')}
      subTitle={
        Number(balance) === 0
          ? t('zero_wallet_balance')
          : `${staticNumberFormatter(balance) ?? '-'} ${t('toman')}`
      }
      containerStyle={styles.container}
      {...props}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 12,
  },
});
